import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_ZONES_V2, CREATE_ZONES_V2_SUCCESS, CREATE_ZONES_V2_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createZonesV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/benefit-type/airport-transfer/zone`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_ZONES_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: CREATE_ZONES_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_ZONES_V2_ERROR, payload: error });
  }
}

export function* watchcreateZonesV2() {
  yield takeEvery(CREATE_ZONES_V2, createZonesV2);
}

function* createZonesV2Saga() {
  yield all([fork(watchcreateZonesV2)]);
}

export default createZonesV2Saga;
